import BasicPillar from './BasicPillar.jsx'
import RevenueSyncBanner from '../components/RevenueSyncBanner.jsx'

/**
 * Revenue pillar.
 *
 * Renders the standard pillar shell from BasicPillar, prefixed with a
 * small "HubSpot sync" banner that shows the last-synced time + a
 * manual "Sync now" button + any error from the auto-sync poll.
 *
 * The sync runs automatically (on app mount + every 10 min via the
 * useRevenueAutoSync hook at the app root). The banner is purely for
 * visibility and manual refresh.
 */
export default function RevenuePillar() {
  return (
    <div>
      <RevenueSyncBanner />
      <BasicPillar
        pillarId="revenue"
        description={
          'Q2 2026 revenue targets. Sub-goal current values sync from HubSpot automatically.'
        }
      />
    </div>
  )
}
